import { Tooltip } from "react-tooltip"
import roundtocloses0_5_value from "../../V2Leaderboard/Utils/roundToClosest_0_5"
import showFloatToPercentage from "../../V2Leaderboard/Utils/showFloatToPercentage"


const ForecastShareTool = ({ image }) => {

  return <Tooltip
    id={'forecast-tooltip-' + image.mediaId}
    style={{ zIndex: 1100 }}
  >
    <div className="text-[10px] font-light  max-w-[75vw]">
      <h3 className="text-center">Forecast of image trends </h3>
      <div className="flex justify-between py-1 text-xs">
        <div className={`px-2 text-yellow-500 font-semibold text-wrap shrink-0`}>Forecast score of image </div><div>{image.forecastScore && Object.keys(image.forecastScore) ? <span>{roundtocloses0_5_value(showFloatToPercentage(Object.keys(image.forecastScore).reduce((prev, current) => image.forecastScore[current] + prev, 0)))}</span> : 0} </div>
      </div>
      <div className="ml-2">{
        Object.keys(image.forecastScore) ?
          <table className="table-auto w-full table">
            <thead>
              <tr className="border-b-[0.2px] border-b-white">
                <th className="px-2">Category</th>
                <td className="px-2">Forecast </td>
              </tr>
            </thead>
            <tbody>
              {Object.keys(image.forecastScore)
                .map(category => <tr key={category}>
                  <td><p className="text-wrap pr-2">{category}</p></td>
                  <td className="text-center">{roundtocloses0_5_value(showFloatToPercentage(image.forecastScore[category]))}</td>
                </tr >)}
            </tbody>
          </table>
          : null

      }
      </div>

    </div>
  </Tooltip>
}

export default ForecastShareTool
